import { eventBus } from 'EventBus/';

export const modal = {
  name: 'modal',
  inserted: (el, { value }) => {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      eventBus.$emit(value.modalid, value);
    });
  },
};
